module.exports = __webpack_public_path__ + "static/crema-de-elote-y-pimento-amarrillo-1-1330d417adefa24664a60df4d8452c94.jpg";